module.exports = __webpack_public_path__ + "static/media/emailSomeoneElse.0b0dcd1e.jpg";